<!-- version 2021/05/20 -->
<template>
    <a href="" class="btn d-flex align-items-center">
        <!-- <i v-if="active" class="check-square fa fa-2x fa-check-square"></i>
        <i v-else class="square-o fa fa-2x fa-square-o"></i> -->
        <i v-if="active" class="fa fa-lg fa-check-square active"></i>
        <i v-else class="fa fa-lg fa-check-square "></i>
        {{ text }}
    </a>
</template>

<script>
    export default {
        props: {
            text: String,
            active: Boolean
        }
    }
</script>

<style lang="sass" scoped>
  a
    border-radius: 6px !important
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) !important
    background-color: #FFF !important
    color: #28c3cd !important
    display: flex
    justify-content: center
    align-items: center
  i
    font-size: 24px
    margin-right: 10px
    color: rgba(0, 0, 0, 0.08)
    &.active
      color: rgb(40, 195, 205)

</style>
